import React, { useRef } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { LazyImage } from "components"
import FoodCategoriesChipChevron from "./FoodCategoriesChipChevron"
import classes from "./FoodCategoriesChip.module.scss"

const FoodCategoriesChip = props => {
  const { category, onSelect = () => { }, isDragging } = props

  const i18n = useTranslation()[1]

  const chipRef = useRef(null)

  const handleChangeFilter = (category) => {
    if (isDragging) return

    onSelect(category)
  }

  const showSubcategoryButton =
    category.children.length > 0

  const dir = i18n.dir(i18n.language)

  const isLtr = dir === "ltr"

  return (
    <div
      ref={chipRef}
      className={classes["item"]}
    >
      <div
        onClick={() => handleChangeFilter(category)}
        className={classes["name"]}
      >
        <LazyImage
          src={category.image}
          imageWidth={50}
          quality={80}
          className={clsx(classes["image"], isLtr && classes["image-ltr"])}
          alt=""
        />
        <strong className={classes["text"]}>
          {category.name}
        </strong>
      </div>

      {
        showSubcategoryButton &&
        <FoodCategoriesChipChevron
          chipRef={chipRef}
          category={category}
          handleChangeFilter={handleChangeFilter}
        />
      }
    </div>
  )
}

export default React.memo(FoodCategoriesChip)